<style lang="stylus">
    .adbox-float
        position absolute
        right 10px
        top 15px
        object-fit contain
        z-index 1
        img
            width 100%
            cursor pointer

        .close-btn
            position absolute
            top 0
            right 8px
            width 16px
            height 30px
</style>

<template>
    <div class="adbox-float" v-if="showFloat">
        <img :src="activityData.imgUrl" alt="" @click="openLink(activityData.linkUrl)" />
        <div class="close-btn">
            <img :src="closeBtn" alt="" @click="closeBox" />
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class ADFloat extends Vue {
        @Prop()
        activityData;
        @Prop()
        activityTime;
        @Prop()
        activityKey;
        @Prop()
        isCheckLog;

        closeBtn: any = require("@/home/assets/img/publish_close.svg");
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        // 检验是否启用，是否处于活动时间，是否会员屏蔽，是否手动关闭
        get showFloat() {
            return this.$store.state.showFloat && !this.showAlert && this.isCheckLog;
        }
        get showAlert() {
            return this.$store.state.showAlert && this.isCheckLog;
        }
        setLocal(type) {
            type = `${type}_${this.userInfo.user_id}`;
            let storageItem = JSON.parse(localStorage.getItem(type)) || [];
            storageItem.push(this.activityKey);
            localStorage.setItem(type, JSON.stringify(storageItem));
        }

        openLink(url) {
            let userInfo = "";
            if (this.userInfo && this.userInfo.user_id) {
                userInfo = `&custom=${encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })))}`;
            }
            if (this.internal) {
                let split = /\?/.test(url) ? "&" : "?";
                url = `${url}${split}catalogues=coupononlinebuy&source=floating window${userInfo}`;
                this.$track("clicksale", "click", `saletype: floating window` + `;type:${this.isPC ? "desktop" : "online"}`);
            }
            if (this.isPC) {
                (<any>window).$qt.jsCallOpenUrl(url);
            } else {
                let newTab = window.open("about:blank");
                newTab.location.href = url;
            }
        }
        closeBox() {
            this.$store.commit("setState", {
                type: "showFloat",
                data: false,
            });
            this.setLocal("float_ad");
        }

        checkLog() {
            if (this.$validateLogin(false)) {
                this.$emit("updateActivity");
            } else {
                this.$bus.$on("loginSucc", () => {
                    this.$emit("updateActivity");
                });
            }
        }
        mounted() {
            this.checkLog();
            this.$bus.$on("changeLang", this.checkLog);
        }
        beforeDestroy() {
            this.$bus.$off("loginSucc");
            this.$bus.$off("changeLang");
        }
    }
</script>
